import { create } from "zustand";

interface MessageDataState {
  unreadMessageCounter: number;
  setUnreadMessageCounter: (counter: number) => void;
  clearUnreadMessageCounter: () => void;
  taanaUnreadMessageCounter: number;
  setTaanaUnreadMessageCounter: (counter: number) => void;
  clearTaanaUnreadMessageCounter: () => void;
}

export const useMessageDataStore = create<MessageDataState>((set) => ({
  taanaUnreadMessageCounter: 0,
  unreadMessageCounter: 0,
  setUnreadMessageCounter: (counter) => set({ unreadMessageCounter: counter }),
  clearUnreadMessageCounter: () => set({ unreadMessageCounter: 0 }),
  setTaanaUnreadMessageCounter: (counter) =>
    set({ taanaUnreadMessageCounter: counter }),
  clearTaanaUnreadMessageCounter: () => set({ taanaUnreadMessageCounter: 0 }),
}));
